import { IVisibilityConfig } from '@insync-students-components/ResourceViewer/hooks/useVisibilityConfig/useVisibilityConfig.hook';
import { Assignment } from '@insync-students-lib/models';
import { CmsResource } from '@insync-students-lib/services/cms/cms-api.types';
import { CmsResourceView } from '@modules/Resources/useResourceView';
import { createContext } from 'react';
export interface ResourceViewerContextType {
  assignment: Assignment | null;
  setResourceAssignment: (assignment: Assignment | null) => void;
  resource: CmsResource | null;
  setResource: (resource: CmsResource | null) => void;
  language?: string;
  setLanguage: (id: string) => void;
  visibilityConfig: IVisibilityConfig;
  annotations?: string;
  setAnnotations: (id: string) => void;
  resourceRef?: any;
  setResourceRef?: (ref: any) => void;
  dataLoaded: boolean;
  setDataLoaded: (dataLoaded: boolean) => void;
  resourceView: CmsResourceView | null;
}
export const ResourceViewerContext = createContext<ResourceViewerContextType | undefined>(undefined);